import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VehicleNegotiationCreateDTO, VehicleNegotiationEditDTO, VehicleNegotiationEnrichmentDTO, VehicleNegotiationEnrichmentResult } from 'src/app/core/interfaces/negotiation/vehicle-negotiation';
import { VehicleNegotiationInfoUser } from 'src/app/core/interfaces/negotiation/vehicle-negotiation-info-user';
import { ResponseList } from 'src/app/core/interfaces/response-list';
import { VehicleNegotiationParams } from 'src/app/core/interfaces/VehicleNegotiationsParams';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransportRequestsService {

  constructor(
    private httpClient: HttpClient,
    private endpoints: Endpoints
  ) { }

  public getVehicleNegotiations(vehicleNegotiationParams: VehicleNegotiationParams = {}): Observable<ResponseList<VehicleNegotiationInfoUser>> {
    let params = new HttpParams();
    if (vehicleNegotiationParams.cargoId) {
      params = params.append('cargoId', vehicleNegotiationParams.cargoId);
    }
    if (vehicleNegotiationParams.consecutive) {
      params = params.append('consecutive', vehicleNegotiationParams.consecutive);
    }
    if (vehicleNegotiationParams.creatorUserId) {
      params = params.append('creatorUserId', vehicleNegotiationParams.creatorUserId);
    }
    if (vehicleNegotiationParams.licensePlates) {
      params = params.append('licensePlates', vehicleNegotiationParams.licensePlates);
    }
    if (vehicleNegotiationParams.pageKey) {
      params = params.append('pageKey', vehicleNegotiationParams.pageKey.toString());
    }
    if (vehicleNegotiationParams.pageSize) {
      params = params.append('pageSize', vehicleNegotiationParams.pageSize.toString());
    }
    if (vehicleNegotiationParams.state) {
      params = params.append('state', vehicleNegotiationParams.state);
    }
    if (vehicleNegotiationParams.userId) {
      params = params.append('userId', vehicleNegotiationParams.userId);
    }
    return this.httpClient.get<ResponseList<VehicleNegotiationInfoUser>>(
      `${environment.urlServerTeclogi}${this.endpoints.getVehicleNegotiations}`,
      { params }
    );
  }

  public negotiationsVehiclesOffers(idOffer: string, action: 'Accepted' | 'Refuse' | 'Negotiate' | 'Created', observation?: string): Observable<any> {
    const body = { action };
    if (observation) body['observation'] = observation;
    return this.httpClient.put<any>(
      `${environment.urlServerTeclogi}${this.endpoints.negotiationsVehiclesOffers}${idOffer}`,
      body
    );
  }

  public createVehicleNegotiation(vehicleNegotiation: VehicleNegotiationCreateDTO): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.urlServerTeclogi}${this.endpoints.getVehicleNegotiations}`,
      vehicleNegotiation
    );
  }

  public editVehicleNegotiation(vehicleNegotiation: VehicleNegotiationEditDTO, offerId: string): Observable<any> {
    return this.httpClient.put<any>(
      `${environment.urlServerTeclogi}${this.endpoints.getVehicleNegotiations}/${offerId}`,
      vehicleNegotiation
    );
  }

  public enrichVehicleNegotiationOffers(cargoId: string, offerIds?: string[]): Observable<VehicleNegotiationEnrichmentResult> {
    const body: VehicleNegotiationEnrichmentDTO = { cargoId };
    if (offerIds && offerIds.length) body.offerIds = offerIds;
    return this.httpClient.put<VehicleNegotiationEnrichmentResult>(
      `${environment.urlServerTeclogi}${this.endpoints.enrichVehicleNegotiationOffers}`,
      body
    );
  }
}
